import i18n from '@/locales'

export const ELK_STORAGE = {
  cloud_efficiency: i18n.t('middleware.cloud_efficiency'),
  CLOUD_SSD: i18n.t('middleware.cloud_ssd'),
  cloud_essd: i18n.t('middleware.cloud_essd'),
}

export const ELK_CATEGORY = {
  oss: i18n.t('middleware.categoary.oss'),
  basic: i18n.t('middleware.categoary.basic'),
  platinum: i18n.t('middleware.categoary.platinum'),
  'x-pack': i18n.t('middleware.categoary.x-pack'),
  advanced: i18n.t('middleware.categoary.advanced'),
}
